import PropTypes from 'prop-types'
import React from 'react'

import { imageUrl } from '../../ThemeView'
import LazyImage from '../../LazyImage'

const Logistics = ({ shippingLogos }) => {
  if (!shippingLogos.length) return null
  return (
    <ul className="logistics">
      {shippingLogos.map((logo, index) => (
        <li className="logistics-item" key={logo.id}>
          <div className="logistics-item-box">
            <LazyImage
              className="logistics-item-box-logo"
              src={logo.path ? imageUrl(logo.path) : `/themes/epages.base/assets/logistics/${logo.filename}`}
              srcSet={
                logo.path
                  ? `${imageUrl(logo.path, { height: 22 })} 1x, ${imageUrl(logo.path, { height: 44 })} 2x`
                  : null
              }
              alt={logo.title}
              title={logo.title}
            />
          </div>
        </li>
      ))}
    </ul>
  )
}

Logistics.propTypes = {
  shippingLogos: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      path: PropTypes.string,
      filename: PropTypes.string,
    }),
  ),
}
Logistics.defaultProps = {
  shippingLogos: [],
}

export default Logistics
